import React from "react";
import Card from "react-bootstrap/Card";

export default class IndexTranscriberBonus extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {
      transcribeOnly,
      nextTarget,
      minutesRemaining,
      targetClass,
      minutesThisWeek,
      percentToNextTarget,
    } = this.props;

    let bonusMessage;
    switch (nextTarget) {
      case 100:
        bonusMessage = (
          <p className="large">
            Earn an extra $2 bonus for transcribing 100 minutes this week!
          </p>
        );
        break;
      case 200:
        bonusMessage = (
          <p className="large">
            Earn a $5 bonus for transcribing 200 minutes this week!
          </p>
        );
        break;
      case 400:
        bonusMessage = (
          <div>
            <p className="large">
              Congratulations! You earned to win the $5 bonus this week by
              transcribing more than 200 minutes. Wahooooooooo!
            </p>
            <br />
            <br />
            <p>Earn another $7.5 bonus by reaching 400 minutes.</p>
          </div>
        );
        break;
      case 600:
        bonusMessage = (
          <div>
            <p className="large">
              WOW! You earned BOTH the $5 bonus and the $7.5 bonus ($12.5 total)
              by transcribing more than 400 minutes this week. You are a
              transcription hero!
            </p>
            <br />
            <br />
            <p>
              Surprise! Earn a $10 bonus for transcribing 600 minutes this week.
              You can do it!
            </p>
          </div>
        );
        break;
    }

    let cardBody;

    if (nextTarget === null && transcribeOnly) {
      cardBody = (
        <div>
          Thanks for your incredible work this week!!! You did over 600 minutes.
          Wow!
          <img
            src="https://viralviralvideos.com/wp-content/uploads/GIF/2014/10/Dance-Party-GIF.gif"
            alt="Dance Party"
          />
        </div>
      );
    } else if (transcribeOnly) {
      cardBody = (
        <div>
          {bonusMessage}
          <p className="large">{minutesRemaining.toFixed(1)} minutes to go!</p>
          <p className="p small">
            *Calls must receive a quality rating of at least 4.
          </p>
          <div className="progress">
            <div
              aria-valuemax={nextTarget}
              aria-valuemin="0"
              aria-valuenow={minutesThisWeek}
              className={"progress-bar " + targetClass}
              role="progressbar"
              style={{ width: percentToNextTarget.toFixed(1) + "%" }}
            />
          </div>
        </div>
      );
    }

    return <Card body>{cardBody}</Card>;
  }
}
